import { Stack, styled } from "@mui/material";

const StyledContent = styled(Stack)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start", // Mudado de flex-end para flex-start para melhor controle do scroll
    rowGap: theme.spacing(2),
    flex: "1 1 0",
    minHeight: 0,
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(10), // Espaço extra no final para garantir que a última mensagem apareça inteira
    overflow: "auto",
    scrollBehavior: "auto",
}));

export { StyledContent };
